import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_EMERGENCY_FUND_GOAL_API } from '../EmergencyFundWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import InputAutocomplete from '../../InputAutocomplete/InputAutocompleteView';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';

export const validator = (year = '', options) => () => {
  if (options.indexOf(year.toString()) < 0) {
    return ['Please specify a valid year.'];
  }

  return [];
};
class TargetDateView extends React.Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const { isPopulated, clientId, store, targetYear, defaultTargetYear, workflowId } = this.props;

    if (!previousIsPopulated && isPopulated) {
      if (!isNumeric(targetYear)) {
        store(workflowId)(
          {
            [BACKEND_EMERGENCY_FUND_GOAL_API]: { FundedDate: defaultTargetYear },
          },
          clientId,
        );
      }
    }
  }

  render() {
    const {
      workflowId,
      branch,
      clientId,
      store,
      targetYear,
      defaultTargetYear,
      yearsOptions,
      onPostProcess,
      goal,
    } = this.props;

    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId} id="EmergencyFundTargetDate">
        <Validation
          workflowId={workflowId}
          validationId={`${BACKEND_EMERGENCY_FUND_GOAL_API}.FundedDate`}
        />

        <h2>When would you like to complete this goal?</h2>

        <h3>We recommend funding your emergency fund by {defaultTargetYear}.</h3>

        <AdvForm>
          <ul className="horizontal">
            <li>
              <InputAutocomplete
                isUnder
                isInteger
                inputmode="numeric"
                placeholder="Year"
                id="adv-year"
                placeholderClassName="adv-workflows-placeholder-large"
                className="lg text-center"
                value={targetYear}
                options={yearsOptions}
                onChange={inputTextChanged(
                  clientId,
                  store(workflowId),
                  `${BACKEND_EMERGENCY_FUND_GOAL_API}.FundedDate`,
                )}
                showEmptyCustomMessage
                customEmptyMessage="Select Year"
              />
            </li>
          </ul>
        </AdvForm>

        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validator(targetYear, yearsOptions)}
          validationId={`${BACKEND_EMERGENCY_FUND_GOAL_API}.FundedDate`}
          workflowId={workflowId}
          backendKey={BACKEND_EMERGENCY_FUND_GOAL_API}
          onPostProcess={data => onPostProcess(data, goal)}
        />
      </AdvWorkflowStep>
    );
  }
}

TargetDateView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  targetYear: PropTypes.number.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  defaultTargetYear: PropTypes.number.isRequired,
  yearsOptions: PropTypes.arrayOf().isRequired,
  onPostProcess: PropTypes.func.isRequired,
  goal: PropTypes.shape().isRequired,
};

export default TargetDateView;
